<template>
  <div>
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;筛选条件</span>
      </h4>
      <div class="selectColor">
        <div class="row">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-row>
                <el-col :span="4">
                  机构
                </el-col>
                <el-col :span="17">
                  <el-cascader placeholder="请输入" :options="options" filterable change-on-select v-model="manageCom"> </el-cascader>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10">
              <el-row>
                <el-col :span="4">
                  时间区间
                </el-col>
                <el-col :span="20">
                  <el-date-picker
                    type="daterange"
                    align="right"
                    :clearable="false"
                    unlink-panels
                    :editable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    @change="dateChange"
                    v-model="dateStart"
                    class="maxWidth"
                    :picker-options="pickerOptions2"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">考试类型</el-col>
                <el-col :span="17">
                  <el-select v-model="req.examType" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <!-- 银保、续期、团险渠道，---考试类型只显示：互联网，机构不显示T4。 查询结果和导出结果，不显示T4代码和T4名称。 -->
                    <el-option v-show="channelType == 'FC'" label="新人" value="0">新人</el-option>
                    <el-option v-show="channelType == 'FC'"  label="地区" value="1">地区</el-option>
                    <!-- 新险种考试类增加：团险、收展内勤渠道 -->
                    <el-option v-show="['FC', 'GP', 'RP'].includes(channelType)"  label="新险种" value="RISK">新险种</el-option>
                    <el-option v-show="channelType == 'FC'" label="新人险种" value="NEW_RISK">新人险种</el-option>
                    <!-- ITD-3822 查询条件个险渠道，考试类型增加：互联网 -->
                    <el-option label="互联网" value="INTERNET">互联网</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="row">
        <div>
          <el-row :gutter="20">
            <el-col :span="7">
              <el-row>
                <el-col :span="4">
                  姓名
                </el-col>
                <el-col :span="17">
                  <el-input v-model="req.name" placeholder="请输入姓名"></el-input>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10">
              <el-row>
                <el-col :span="4">
                  业务编码
                </el-col>
                <el-col :span="20">
                  <el-input class="maxWidth" v-model="req.idCardNum" placeholder="请输入业务编码"></el-input>
                </el-col>
              </el-row>
            </el-col>
            <div class="btnp">
              <el-button type="primary" @click="reset()">重置</el-button>
              <el-button type="primary" @click="search()">查询</el-button>
            </div>
            <!-- <el-col :span="4">
                <el-button type="primary" @click="reset()">重置</el-button>
                <el-button type="primary" @click="search()">查询</el-button>
            </el-col> -->
            <!-- <el-col :span="2">
              <el-button type="primary" @click="search()">查询</el-button>
            </el-col> -->
          </el-row>
        </div>
      </div>
    </div>
    <div class="main">
      <h4 class="title1">
        <span>&nbsp;&nbsp;查询结果</span>
        <el-button class="right" type="primary" @click="exportResult">导出</el-button>
      </h4>
      <div>
        <el-table max-height="370" :data="result" style="width: 100%">
          <el-table-column fixed type="index" label="编号" width="50" align="center"> </el-table-column>
          <el-table-column prop="t2Name" label="T2名称" width="80" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t2Name">{{ scope.row.t2Name }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t2Code" label="T2代码" width="80" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t2Code">{{ scope.row.t2Code }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t3Name" label="T3名称" width="80" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t3Name">{{ scope.row.t3Name }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t3Code" label="T3代码" width="80" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t3Code">{{ scope.row.t3Code }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t4Name" v-if="channelType == 'FC'" label="T4名称" width="80" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t4Name">{{ scope.row.t4Name }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="t4Code" v-if="channelType == 'FC'" label="T4代码" width="80" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.t4Code">{{ scope.row.t4Code }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="agentName" label="姓名" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.agentName">{{ scope.row.agentName }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="idCardNum" label="业务编码" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.idCardNum">{{ scope.row.idCardNum }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="paperType" label="考试类型" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.paperType">{{ scope.row.paperType }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="paperType" label="险种编码" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.riskCode">{{ scope.row.riskCode }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="考试成绩" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.score || scope.row.score == 0">{{ scope.row.score }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="result" label="考试结果" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.result">{{ scope.row.result }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="times" label="考试次数" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.times">{{ scope.row.times }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="examStartDate" label="考试时间" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.examStartDate">{{ scope.row.examStartDate }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="invigilate" label="监考内勤" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.invigilate">{{ scope.row.invigilate }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="terminal" label="考试终端" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.terminal">{{ scope.row.terminal }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="clientip" label="客户端IP" width="130" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.clientip">{{ scope.row.clientip }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>

          <el-table-column prop="location" label="考试定位" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.location">{{ scope.row.location }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="equipmentNo" label="设备号" width="100" align="center">
            <template slot-scope="scope">
              <el-popover trigger="hover" v-if="scope.row.equipmentNo" placement="top">
                <p style="text-align: center">{{ scope.row.equipmentNo }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.equipmentNo.substr(0, 4) + '···' }}</el-tag>
                </div>
              </el-popover>
              <div v-else slot="reference"></div>
            </template>
          </el-table-column>
          <el-table-column prop="osVersion" label="操作系统版本" width="120" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.osVersion">{{ scope.row.osVersion }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="mac" label="mac地址" width="100" align="center">
            <template slot-scope="scope">
              <div slot="reference" v-if="scope.row.mac">{{ scope.row.mac }}</div>
              <div slot="reference" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="试卷复现" width="100" align="center" v-if="show">
            <template slot-scope="scope">
              <el-button @click="review(scope.$index, scope.row)" type="text" size="small">
                复现
              </el-button>
              <!--<span style="cursor:pointer;color: #194793;border-bottom: 1px solid #194793" @click="review(scope.$index, scope.row)">复现</span>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          class="my-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="req.startIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          prev-click
          next-click
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  data() {
    return {
      options: [{}],
      manageCom: [],
      manageCom1: [],
      dateStart: '',
      dateEnd: '',
      req: {
        manageCom: 'HO',
        examType: null,
        name: null,
        idCardNum: '',
        startDate: '',
        endDate: '',
        startIndex: 1,
        pageSize: '10'
      },
      result: [],
      total: 0,
      loadUrl: '',
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      reqCopy: {},
      manageComCopy: [],
      show: false,
      channelType: ''
    };
  },
  watch: {
    loadUrl(newValue, oldValue) {
      console.log(newValue);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = newValue;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    manageCom(newValue, oldValue) {
      if (newValue.length === 1 && oldValue.length != 0) {
        this.req.manageCom = newValue[0];
      }
      if (newValue.length === 2 && oldValue.length != 0) {
        this.req.manageCom = newValue[1];
      }
      if (newValue.length === 3 && oldValue.length != 0) {
        this.req.manageCom = newValue[2];
      }
      if (newValue.length === 4 && oldValue.length != 0) {
        this.req.manageCom = newValue[3];
      }
    }
  },
  methods: {
    reset() {
      // 重置
      this.initDate();
      this.manageCom = this.manageCom1;
      this.req.manageCom = this.manageCom;
      // console.log(this.req.manageCom,'manage')
      // console.log(this.manageCom,',anage')
      this.req.examType = null;
      this.req.name = null;
      this.req.idCardNum = '';
      this.req.pageSize = 10;
      this.req.startIndex = 1;
      this.search();
      // this.initManageCom()
    },
    // --------分页
    handleSizeChange(value) {
      this.req.pageSize = value;
      this.req.startIndex = 1;
      this.search();
    },
    handleCurrentChange(value) {
      // this.req.startIndex = value
      this.search(value);
    },
    dateChange(value) {
      let startDate = new Date(value[0]);
      let endDate = new Date(value[1]);
      this.req.startDate = startDate.getTime();
      this.req.endDate = endDate.getTime();
    },
    review(index, row) {
      console.log(231, this.reqCopy);
      this.$router.push({ name: 'paperReview', params: { paperCode: row.paperCode, req: this.reqCopy, manageCom: this.manageComCopy,riskCode:row.riskCode } });
    },
    initManageCom() {
      let that = this;
      api.post(url.initAllManageCom, {}, function(res) {
        console.log('机构', res);
        that.options = JSON.stringify(res.data)
          .trim()
          .replace(/"children":\[\],/g, '');
        console.log(that.options);
        that.options = JSON.parse(that.options);
        that.manageCom = that.options[0].value;
        // console.log(that.manageCom,'222')
        that.manageCom1 = that.options[0].value;
        that.req.manageCom = that.options[0].value;
        let req = that.$route.params.req;
        let manageCom = that.$route.params.manageCom;
        if (req) {
          that.req = req;
        }
        if (manageCom) {
          that.manageCom = manageCom;
        }
        that.search();
        // that.options.push({label: '全国', value: 'HO'})
      });
    },
    search(v) {
      if (v) {
        this.req.startIndex = v;
      } else {
        this.req.startIndex = 1;
      }
      let that = this;
      api.post(url.getExamDetails, this.req, function(res) {
        console.log('列表', res);
        that.result = res.data.examDetailList;
        that.total = res.data.count;
        that.show = res.data.showReview;
        that.reqCopy = JSON.parse(JSON.stringify(that.req));
        that.manageComCopy = JSON.parse(JSON.stringify(that.manageCom));
      });
    },
    initDate() {
      let current = new Date();
      let startOfMonth = this.moment(current)
        .startOf('month')
        .format('YYYY/MM/DD');
      let endOfMonth = this.moment(current)
        .endOf('month')
        .format('YYYY/MM/DD');
      this.req.startDate = new Date(startOfMonth).getTime();
      this.req.endDate = new Date(endOfMonth).getTime();
      this.dateStart = [new Date(startOfMonth), new Date(endOfMonth)];
    },
    exportResult() {
      let that = this;
      api.post(url.exportExamDetail, this.req, function(res) {
        if (res.result.isSuccess) {
          that.loadUrl = res.data;
        } else {
          console.log('失败');
        }
      });
    }
  },
  mounted() {
    // this.req.manageCom = this.manageCom[0]
    // this.show=this.$parent.show
    this.initDate();
    // this.search()
    this.initManageCom();
    this.channelType = window.sessionStorage.getItem('channelType')||''
  },
  created(){
    if(window.sessionStorage.getItem('startDate')){
      this.req.startDate = window.sessionStorage.getItem('startDate')
      window.sessionStorage.removeItem('startDate')
    }
    if(window.sessionStorage.getItem('endDate')){
      this.req.endDate = window.sessionStorage.getItem('endDate')
      window.sessionStorage.removeItem('endDate')
    }
  },
  destroyed(){
    window.sessionStorage.setItem('startDate',this.req.startDate)
    window.sessionStorage.setItem('endDate',this.req.endDate)
  }
};
</script>

<style scoped>
.title1 {
  background: rgb(245, 246, 250);
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}

.selectColor {
  padding-bottom: 1px;
}
.select >>> .el-row{
  width:100%;
  padding-left:0;
  padding-right:0;
  margin-left: 0;
  margin-right: 0;
}
.select >>> .el-cascader{
  width:100%;
}
/* .select >>> .el-col-offset-6{
  text-align: center;
} */
.row {
  margin-top: 20px;
  padding-left: 20px;
  line-height: 50px;
}

.main {
  margin-top: 20px;
}

.footer {
  padding: 10px 0 30px 0;
}

.right {
  margin: 5px 22px 0 0;
  float: right;
}

.maxWidth {
  width: 100%;
}
.btnp{
  margin-right: 12px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/paperDetails.vue